import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImmoOverviewStateService {
  private selectedView = 'new';
  private selectedPrintView = 'print';
  private selectedAppointmentView = 'new';
  private selectedJobOverviewView = 'year';

  public getSelectedView() {
    return this.selectedView;
  }

  public setSelectedView(selectedView: string) {
    this.selectedView = selectedView;
  }

  public getSelectedPrintView() {
    return this.selectedPrintView;
  }

  public setSelectedPrintView(selectedPrintView: string) {
    this.selectedPrintView = selectedPrintView;
  }

  public getSelectedAppointmentView() {
    return this.selectedAppointmentView;
  }

  public setSelectedAppointmentView(selectedAppointmentView: string) {
    this.selectedAppointmentView = selectedAppointmentView;
  }

  public getSelectedJobOverviewView() {
    return this.selectedJobOverviewView;
  }

  public setSelectedJobOverviewView(selectedJobOverviewView: string) {
    this.selectedJobOverviewView = selectedJobOverviewView;
  }
}
